<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          color="green"
          :title="$t('Dashboard.tableHeading')"
          :text="$t('Dashboard.tableDescription')"
        >
          <v-subheader>Getting Started</v-subheader>
            <v-list-item
              v-for="item in gettingStartedItems"
              :key="item.title"
              @click="$router.push({ path: item.path })">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.subTitle }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      gettingStartedItems: [
        {
          title: 'Start a new Assessment',
          path: '/assessment',
          subTitle: 'Start a new client assessment now',
        },
        {
          title: 'Continue an existing Assessment',
          path: '/assessments',
          subTitle: 'Continue with an existing assessment you\'ve started',
        },
      ],
    };
  },
  computed: {
    ...mapState('assessments', ['assessmentsWithClients']),
  },
  mounted() {
    if (this.$auth.authentication === null) {
      this.$router.push({ path: '/login' });
    } else {
      this.getUserAssessment(this.$auth.authentication.userName);
    }
  },
  methods: {
    ...mapActions('assessments', ['getUserAssessment']),
  },
};
</script>
